import pLimit from "p-limit";
import {
    UPLOAD_FILE
} from '../const/general'
import cliAuth from './axios_cli';


export default async function multipartUploadProc(
    movie, original_s3_prefix, setCounter
    // , info1, info2
) {

    const key = original_s3_prefix + movie.id + movie.ext;

    let uploadId;

    try {
        const res = await cliAuth.post("upload/init/", {
            key,
        });
        uploadId = res.data.uploadId;

        const file = movie.uploadFile
        const fileSize = file.size;
        const maxPart = Math.ceil(fileSize / UPLOAD_FILE.CHUNK_SIZE);

        const limit = pLimit(UPLOAD_FILE.CHUNK_PROMISE_COUNT);

        const uploadTasks = [];
        const partsInfo = [];

        const urlsRes = await cliAuth.post("upload/urls/", {
            key,
            uploadId,
            parts: maxPart
        });

        const urls = urlsRes.data.urls;

        for (const part of urls) {

            uploadTasks.push(
                limit(async () => {

                    const partNumber = part.partNumber

                    const slice_start =
                        (partNumber - 1) * UPLOAD_FILE.CHUNK_SIZE;

                    const slice_end = Math.min(
                        partNumber * UPLOAD_FILE.CHUNK_SIZE,
                        fileSize
                    );

                    const slice = file.slice(slice_start, slice_end);

                    const uploadRes = await fetch(part.url, {
                        method: "PUT",
                        body: slice,
                    });

                    if (!uploadRes.ok) {
                        throw new Error(`Upload failed ${uploadRes.status}`);
                    }

                    const etag = uploadRes.headers.get("ETag");

                    partsInfo[partNumber - 1] = {
                        PartNumber: partNumber,
                        ETag: etag,
                    };

                    setCounter(prev => prev + 1)

                })
            )
        }

        const results = await Promise.allSettled(uploadTasks);

        const rejected = results.find(r => r.status === "rejected");

        if (rejected) {
            throw rejected.reason;
        }

        const sortInfo = partsInfo.sort((a, b) => a.PartNumber - b.PartNumber)

        await cliAuth.post("upload/complete/", {
            key,
            uploadId,
            parts: sortInfo,
        });
        return true

    } catch (err) {
        console.error(err);

        if (uploadId) {
            await cliAuth.post("upload/abort/", {
                key,
                uploadId,
            });
        }
        throw err
    }
};
